import urlRegexSafe from 'url-regex-safe'

// isTargetURL2 fixes tests to see if a URL is an Target domain (will match target.com, target.internal, tgt.interal, tgt.com, k8s.tgt) or targetpayandbenefits.com
const isTargetURL = (url) => {
  try {
    const parsedUrl = new URL(url) // Use URL constructor for reliable parsing
    const hostname = parsedUrl.hostname // Extract hostname properly

    // Regular expression to match allowed hostnames
    const targetRegEx =
      /^(.*\.)?(target|tgt|alight|mybeaconwellbeing|tmgivingfund|targetirp|irpstart|forms\.office)\.com$/

    // Check if the hostname matches the allowed pattern
    if (targetRegEx.test(hostname)) {
      return true
    }

    if (
      /^wd\d+\.myworkday\.com$/.test(hostname) &&
      parsedUrl.pathname.startsWith('/target/')
    ) {
      return true
    }

    if (
      /^https:\/\/emergencyassistancefdn\.org\/wp-content\/uploads\/2021\/02\/eCheck-Retrieval-Guide(?:_spanish_latin-america)?\.pdf$/.test(
        url,
      )
    ) {
      return true
    }

    return false
  } catch (e) {
    console.error('Error parsing URL:', e) // Log the error for debugging
    return false // If URL parsing fails, return false
  }
}

// isValidURLFormat tests to see if url includes protocol
const isValidURLFormat = (url) => {
  const acceptedFormat =
    /^(https?:\/\/)([A-Za-z0-9](?:[A-Za-z0-9-]+[A-Za-z0-9])?[.])*[\S]+(:([1-9]|[1-9][0-9]+)+)?(\s*)?$/
  var urlToMatch = ''
  var urlSections = url.split('//')
  if ((urlSections[0] === 'https:') | (urlSections[0] === 'http:')) {
    urlToMatch = urlSections[0] + '//' + urlSections[1].split('/')[0]
    const matches = urlToMatch.match(acceptedFormat)
    if (matches) {
      return true
    }
  }
  return false
}

const parseURLsFromText = (text) => {
  if (text) {
    const matches = text.match(urlRegexSafe())
    if (matches != null) {
      return matches
    }
  }
  return []
}

// Input:
//   - String: input
//   - String: inputType (must be text, email, phone, store, teammember, location)
//   - String: returnType (must be 'boolean' or 'text')
//   - Boolean: countryLinkRestrictionflag (false if not restriction)
// Output:
//   - If type is boolean, return boolean (true || false)
//   - If type is text, return error message
export function formValidation(
  input,
  inputType,
  returnType,
  countryLinkRestrictionFlag,
) {
  var iserror = true
  var errorMessage = ''
  if (typeof countryLinkRestrictionFlag == 'undefined') {
    countryLinkRestrictionFlag = false
  }

  // check if text
  if (inputType === 'text') {
    if (typeof input == 'undefined') {
      input = ''
    }

    // check if the string is empty
    if (input !== '' && input !== null) {
      // check if input contains email addresses and then validate if target email
      var emailsArray = input.match(
        /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi,
      )
      if (emailsArray) {
        for (var x = 0; x < emailsArray.length; x++) {
          // remove period after .com (regex thing)
          if (emailsArray[x].substring(emailsArray[x].length - 1) === '.') {
            emailsArray[x] = emailsArray[x].slice(0, -1)
          }
          if (!/^[A-Za-z0-9._%+\-/\\&]+(@target\.com)$/i.test(emailsArray[x])) {
            errorMessage = 'Non Target email'
            break
          }
          // remove email address from input
          input = input.replace(emailsArray[x], '')
        }
      }

      if (errorMessage === '') {
        //check if input contains url
        var urls = parseURLsFromText(input)
        if (urls.length > 0) {
          for (var i = 0; i < urls.length; ++i) {
            // Pass in Country Link Restriction flag and if any url, fail out
            if (countryLinkRestrictionFlag) {
              errorMessage = 'Cannot send links to restricted locations'
              break
            }
            if (!isTargetURL(urls[i])) {
              errorMessage = 'Text contains unapproved link'
              break
            }
            if (!isValidURLFormat(urls[i])) {
              errorMessage = 'Links must begin with https:// or http://'
            }
          }
        }
      }

      if (errorMessage === '') {
        iserror = false
      }
    } else {
      errorMessage = 'Cannot be Empty'
    }
  } else if (inputType === 'email') {
    // check if email
    if (/^[A-Z0-9._%+-/\\&]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(input)) {
      iserror = false
    } else {
      errorMessage = 'Invalid Email Format'
    }
  } else if (inputType === 'phone') {
    // check if phone
    if (/^\+[1-9][0-9]{1,14}$/i.test(input) && input.length >= 12) {
      iserror = false
    } else {
      errorMessage =
        'Phone Number should be in E164 format digits, no dashes, spaces, or any other special characters (ie, +16125550000)'
    }
  } else if (inputType === 'store') {
    // check if store number
    if (/^T[0-9]{4}$/i.test(input)) {
      iserror = false
    } else {
      errorMessage = 'Store format must be T0000'
    }
  } else if (inputType === 'teammember') {
    // check if store number
    if (/^[0-9]{10}$/i.test(input)) {
      iserror = false
    } else {
      errorMessage = 'Team Member format must be 0000000000'
    }
  } else if (inputType === 'location') {
    // check if store number
    if (/^[0-9]{4}$/i.test(input)) {
      iserror = false
    } else {
      errorMessage = 'Location format must be 0000'
    }
  }

  if (returnType === 'boolean') {
    return iserror
  } else if (returnType === 'text' && iserror === false) {
    return errorMessage
  } else if (returnType === 'text' && iserror === true) {
    return errorMessage
  }
  return iserror
}
